import { create } from 'zustand';

type OrderBy = 'date' | 'store' | 'total';

interface ReceiptListState {
  // Filter state
  searchQuery: string;
  orderBy: OrderBy;
  order: 'asc' | 'desc';
  storeFilter: string;
  showOnlyUnreconciled: boolean;
  page: number;
  pageSize: 10 | 25 | 50;

  // Actions
  setSearchQuery: (query: string) => void;
  setOrderBy: (orderBy: OrderBy) => void;
  setOrder: (order: 'asc' | 'desc') => void;
  setStoreFilter: (store: string) => void;
  setShowOnlyUnreconciled: (show: boolean) => void;
  setPage: (page: number) => void;
  setPageSize: (size: 10 | 25 | 50) => void;
  resetFilters: () => void;
}

const initialState = {
  searchQuery: '',
  orderBy: 'date' as OrderBy,
  order: 'desc' as const,
  storeFilter: 'all',
  showOnlyUnreconciled: false,
  page: 1,
  pageSize: 10 as const,
};

export const useReceiptListStore = create<ReceiptListState>((set) => ({
  ...initialState,

  setSearchQuery: (searchQuery) => set({ searchQuery }),
  setOrderBy: (orderBy) => set({ orderBy }),
  setOrder: (order) => set({ order }),
  setStoreFilter: (storeFilter) => set({ storeFilter }),
  setShowOnlyUnreconciled: (showOnlyUnreconciled) => set({ showOnlyUnreconciled, page: 1 }),
  setPage: (page) => set({ page }),
  setPageSize: (pageSize) => set({ pageSize, page: 1 }),
  resetFilters: () => set(initialState),
}));
